'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var moleculeClass = 'fees-calculation';

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      'p',
      { className: moleculeClass + '__header-text' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderFees = function renderFees(fees) {
  if (fees) {
    return _react2.default.createElement(
      'span',
      { className: moleculeClass + '__fees-text' },
      htmlToReactParser.parse(fees.text)
    );
  }
  return null;
};

var renderFooter = function renderFooter(footer) {
  if (footer) {
    return _react2.default.createElement(
      'p',
      { className: moleculeClass + '__footer-text' },
      htmlToReactParser.parse(footer.text)
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: moleculeClass + '__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var FeesCalculation = function FeesCalculation(props) {
  var _props$content = props.content,
      headline = _props$content.headline,
      fees = _props$content.fees,
      footer = _props$content.footer,
      hatchText = _props$content.hatchText;


  return _react2.default.createElement(
    'div',
    { className: moleculeClass + ' col-md-10 col-xs-12 col-sm-9' },
    _react2.default.createElement(
      'div',
      { className: moleculeClass + '__result' },
      renderHeadline(headline),
      renderFees(fees),
      renderFooter(footer)
    ),
    renderHatchText(hatchText)
  );
};

exports.default = FeesCalculation;


FeesCalculation.propTypes = {
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    fees: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    footer: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  })
};

FeesCalculation.defaultProps = {
  content: {
    headline: {
      text: '42 characters maximum or 2 lines'
    },
    fees: {
      text: '12 characters'
    },
    footer: {
      text: '34 characters maximum per line'
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/fees-calculator-calculation/jsx/FeesCalculation.js
// module id = 663
// module chunks = 4